import React, { useEffect, useState } from "react";
import styles from "./UserDetails.module.css";
import { Modal, SubmitButton, TextComponent } from "../../../components";
import { useLocation, useNavigate } from "react-router-dom";
import HeadingComponent from "../../../components/HeadingComponent/HeadingComponent";
import { IoIosArrowBack } from "react-icons/io";
import { Input, Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { DashboardMiddleware } from "../../../Store/Middlewares/DashboardMiddleware";
import moment from "moment";
import { IMAGE_BASE_URL } from "../../../config/APIs";
import AVATAR from "../../../assets/images/avatar.png";
import Pagination from "../../../components/Pagination/Pagination";
import { YardsaleMiddleware } from "../../../Store/Middlewares/YardsalesMiddleware";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { showAlert } from "../../../Store/Actions/GeneralActions";

const UserDetails = () => {

    const navigate = useNavigate();
    const userID = useLocation()?.state?.userId;

    const dispatch = useDispatch();
    const DETAILS = useSelector(state => state.DashboardReducer?.userDetails);
    const YARDSALES = useSelector(state => state.DashboardReducer?.userYardSales);
    const YARDSALES_PAGINATION = useSelector(state => state.DashboardReducer?.userYardSalesPagination);

    const [currentPage, setCurrentPage] = useState(1)
    const [pageLimit, setPageLimit] = useState(6);
    const [reason, setReason] = useState("");
    const [openDeactivateModal, setOpenDeactivateModal] = useState(false);
    const [selectedYardsale, setSelectedYardsale] = useState(null);


    useEffect(() => {
        getDetailsData()
    }, []);

    const getDetailsData = (arg) => {
        const data = {
            id: userID,
            limit: pageLimit,
            page: 1,
        };
        dispatch(DashboardMiddleware.onGetUserDetails(arg || data))
            .then((res) => { })
            .catch((err) => { console.log("Error fetching data:", err) });
    }

    const onClickDeactivateSale = () => {
        if (!reason) {
            dispatch(showAlert({ message: "Please enter a reason for deactivation", type: "Warning" }))
            return;
        }
        setOpenDeactivateModal(false);
        dispatch(YardsaleMiddleware.onDeactivateYardsale({key: "user_yardsale", id: selectedYardsale?.id, reason: reason }))
            .then((res) => {  })
            .catch((err) => { console.log("Error clicking deactivate", err) })
            .finally(() => {
                setReason("");
                setSelectedYardsale(null);
            });
    }

    const columns = [
        {
            title: "Title",
            dataIndex: "title",
            key: "Title",
            render: (text, record) => {
                return (
                    <TextComponent
                        text={text}
                        style={{ color: "black" }}
                    />
                );
            },
        },
        {
            title: "Category",
            dataIndex: "category",
            key: "Category",
            render: (text, record) => {
                return (
                    <TextComponent
                        text={text}
                        style={{ color: "black" }}
                    />
                );
            },
        },
        {
            title: "Start Date",
            dataIndex: "startDate",
            key: "Start Date",
            render: (text, record) => {
                return (
                    <TextComponent
                        text={moment(text).format("MMM, DD, YYYY")}
                        style={{ color: "black" }}
                    />
                );
            },
        },
        {
            title: "End Date",
            dataIndex: "endDate",
            key: "End Date",
            render: (text, record) => {
                return (
                    <TextComponent
                        text={moment(text).format("MMM, DD, YYYY")}
                        style={{ color: "black" }}
                    />
                );
            },
        },
        {
            title: "Interested Buyers",
            dataIndex: "interestedCount",
            key: "Interested Buyers",
            render: (text, record) => {
                return (
                    <TextComponent
                        text={text}
                        style={{ color: "black" }}
                    />
                );
            },
        },

        {
            title: "",
            key: "action",
            render: (_, record) => (
                (record?.status == 'ongoing' || record?.status == 'upcoming') ?
                    <button className={styles.TableButton} onClick={() => {
                        setSelectedYardsale(record);
                        setOpenDeactivateModal(true);
                    }}>
                        Deactivate
                    </button>
                    :
                    <TextComponent
                        text={record?.status.charAt(0).toUpperCase() + record?.status.slice(1)}
                        style={{ color: record?.status == 'completed' ? '#00A36C' : 'red' }}
                    />
            ),
        },
    ];


    return (
        <div className={styles.mainCont}>
            <div className={styles.HeadingDiv}>
                <IoIosArrowBack
                    className={styles.backIcon}
                    onClick={() => navigate(-1)}
                />

                <HeadingComponent
                    text={"User Details"}
                    fontSize={"var(--heading-font-size)"}
                />
            </div>

            <div className={styles.subCont}>
                <div className={styles.leftCont}>

                    <div className={styles.UserBox}>
                        <img src={DETAILS?.profileImage ? IMAGE_BASE_URL + DETAILS?.profileImage : AVATAR} className={styles.UserImg} />
                    </div>

                    <div className={styles.Box}>

                        <TextComponent text={(DETAILS?.firstName ?? ' ') + " " + (DETAILS?.lastName ?? ' ')} className={styles.UserTitle} />


                        <div className={styles.ItemDiv}>
                            <TextComponent text={"Email"} className={styles.LabelStyle} />
                            <TextComponent text={DETAILS?.email} className={styles.descStyle} />
                        </div>

                        <div className={styles.ItemDiv}>
                            <TextComponent text={"Phone"} className={styles.LabelStyle} />
                            <TextComponent text={DETAILS?.phone} className={styles.descStyle} />
                        </div>

                        <div className={styles.ItemDiv}>
                            <TextComponent text={"Location"} className={styles.LabelStyle} />
                            <TextComponent text={DETAILS?.location?.address} className={styles.descStyle} />
                        </div>

                        <div className={styles.ItemDiv}>
                            <TextComponent text={"Joined"} className={styles.LabelStyle} />
                            <TextComponent text={DETAILS?.createdAt ? moment(DETAILS?.createdAt).format('MMM, DD YYYY') : ''} className={styles.descStyle} />
                        </div>


                    </div>
                </div>

                <div className={styles.tableWrapper}>
                    <HeadingComponent
                        text={(DETAILS?.firstName ?? ' ') + "'s Yardsales"}
                        className={styles.TableHeading}
                    />

                    <Table
                        columns={columns}
                        dataSource={YARDSALES}
                        pagination={false}
                        className={styles.table}
                    />

                    {

                        (YARDSALES_PAGINATION?.totalPages > 1) &&
                        <Pagination
                            currentPage={currentPage}
                            totalPages={YARDSALES_PAGINATION?.totalPages}
                            nextButton={(e) => {
                                getDetailsData({
                                    id: userID,
                                    limit: pageLimit,
                                    page: currentPage + 1,
                                });
                                setCurrentPage(currentPage + 1);
                            }}
                            previousButton={(e) => {
                                getDetailsData({
                                    id: userID,
                                    limit: pageLimit,
                                    page: currentPage - 1,
                                });
                                setCurrentPage(currentPage - 1);
                            }}
                        />
                    }

                </div>
            </div>

            <Modal
                footer={false}
                closeIcon={<AiOutlineCloseCircle color="black" size={20} />}
                open={openDeactivateModal}
                onCancel={() => {
                    setOpenDeactivateModal(false)
                }}
            >
                <div className={styles.modal}>
                    <TextComponent text={"Deactivate Yardsale"} className={'modalheading'} />


                    <Input.TextArea
                        className={'modalInput'}
                        placeholder="Reason for deactivation"
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        rows={4}
                    />


                    <div className={'modalFooter'}>

                        <SubmitButton
                            title={"Cancel"}
                            btnClass={'modalBtn'}
                            primary
                            onClick={() => setOpenDeactivateModal(false)}
                        />


                        <SubmitButton
                            title={"Submit"}
                            btnClass={'modalBtn'}
                            secondaryBtn
                            onClick={onClickDeactivateSale}
                        />
                    </div>

                </div>
            </Modal>
        </div>
    );
};

export default UserDetails;
